module.exports = __webpack_public_path__ + "img/coupon-ticket-u.8a380e5f.png";